export function getWeekFixtureLabel(
  weekId: number,
  competitionData: { matches?: { weekId?: number | null; feedUrl?: string | null }[] | null } | null | undefined,
): string {
  const feedUrl = competitionData?.matches?.find(
    (m) => Number(m.weekId) === Number(weekId),
  )?.feedUrl;
  return feedUrl?.trim() || String(weekId);
}
